export const ITEMS_BY_PAGE = 12;
export const DEFAULT_SORT_BY = 'invoiceNumber';
export const INVOICES_FLAG = 'PCC_InvoicesFlag';
